import { gql } from '@apollo/client'

const BOOKING_TRIP_FRAGMENT = gql`
  fragment BookingTripFragment on BookingV2Trip {
    id
    checkInScore
    companyLine {
      id
      name
    }
    segment {
      id
      departureAt
      fare {
        id
        basePrice
      }
      origin {
        id
        name
        city {
          id
          name
          timezone
        }
      }
      destination {
        id
        name
        city {
          id
          name
          timezone
        }
      }
    }
  }
`
const BOOKING_TICKET_FRAGMENT = gql`
  fragment BookingTicketFragment on BookingV2Ticket {
    id
    subtotal
    vat
    discount
    status
    isCheckedIn
    isRewardApplied
    cancellationSource
    seat {
      id
      label
    }
    passenger {
      id
      firstName
      lastName
      type {
        id
        name
      }
      properties {
        id
        name
      }
    }
    trip {
      id
      segment {
        id
        departureAt
      }
    }
    serviceFee {
      price
    }
    ancillaries {
      id
      type
      total
      status
      unitPrice
      quantity
    }
  }
`

export const GET_BOOKINGS = gql`
  query GetBookings($pagination: PaginationV2!, $input: BookingsV2Input!) {
    bookingsV2(input: $input, sorting: { field: "createdAt", order: -1 }, pagination: $pagination) {
      total
      items {
        id
        createdAt
        confirmedAt
        vertical
        isHomePickup
        status
        isTaxInvoiced
        invoicedBy
        isTaxInvoiceable
        userAccount {
          email
          id
          firstName
          lastName
          phoneNumber {
            countryCode
            number
          }
        }
        client {
          source
        }
        country {
          id
          code
        }
        currency {
          id
          code
        }
        salesChannel {
          id
          name
          type
        }
        businessClient {
          id
          name
        }
        buyer {
          firstName
          lastName
          email
          phone
        }
        coupon {
          value
          discountType
          code
        }
        payments {
          id
          user {
            firstName
            lastName
          }
          method
          processor
          status
          chargeID
          authCode
          last4
          tickets {
            id
            subtotal
            vat
            discount
          }
          amount
          paymentListID
        }
        refunds {
          paymentID
          amount
        }
        departureTrips {
          ...BookingTripFragment
        }
        returnTrips {
          ...BookingTripFragment
        }
        tickets {
          ...BookingTicketFragment
        }
        emailsSent {
          id
          address
          status
          reason
          updatedAt
        }
        supportInteractions {
          createdAt
          notificationChannel
          callStatus
          notes
          user {
            username
          }
        }
      }
    }
  }
  ${BOOKING_TRIP_FRAGMENT}
  ${BOOKING_TICKET_FRAGMENT}
`

export const GET_BOOKING = gql`
  query GetBooking($ids: [UUID!]) {
    bookingsV2(input: { ids: $ids }) {
      items {
        id
        vertical
        salesChannel {
          id
          name
        }
        currency {
          id
          code
        }
        buyer {
          firstName
          lastName
          email
          phone
        }
        coupon {
          id
          value
          discountType
          code
        }
        payments {
          id
          method
          processor
          status
          chargeID
          authCode
          last4
          amount
          tickets {
            id
            subtotal
            vat
            discount
          }
        }
        departureTrips {
          ...BookingTripFragment
        }
        returnTrips {
          ...BookingTripFragment
        }
        tickets {
          ...BookingTicketFragment
        }
        refunds {
          amount
        }
      }
    }
  }
  ${BOOKING_TRIP_FRAGMENT}
  ${BOOKING_TICKET_FRAGMENT}
`
